import { Button } from "@fluentui/react-components";
import { Settings24Regular } from "@fluentui/react-icons";
import React from "react";
import styles from "./SystemPromptButton.module.css";

interface Props {
  className?: string;
  onClick: () => void;
  disabled?: boolean;
  style?: React.CSSProperties;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  isInside: boolean;
  hasCustomPrompt: boolean;
}

export const SystemPromptButton = ({ className, style, disabled, onClick, onMouseEnter, onMouseLeave, isInside, hasCustomPrompt }: Props) => {
  const iconColor = hasCustomPrompt ? "#28a745" : isInside ? "#002664" : "#6c757d";

  return (
    <div className={styles.button} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      <Button onClick={onClick} disabled={disabled} className={`${styles.container} ${className ?? ""}`} style={style}>
        {"System Prompt"}
        <div className={styles.promptIcon}>
          <Settings24Regular color={iconColor} />
        </div>
      </Button>
    </div>
  );
};
